import moment from "moment";
import Vue from "vue";
import PosFnBService from "@/services/Pos_Fnb_Service";
import PosService from "@/services/PosService";
import MasterService from "@/services/MasterService";
import { authenticationService } from "@/services/AuthenticationService";
import { Printd } from "printd";
import { router } from "@/router";
import print from "print-js";
import store from "@/store";
import _ from 'lodash';
import { EventBus } from "@/main";
import PosFnbService from "../../services/PosFnbService";
import { getHardwareId, getResourceUsageInfo } from "@/socket.io/init";
import { randomAlphaNumeric } from "@/helper/collection";

function initialState() {
  return {
    // Order Details
    FnbStations: [],
    selectedStation: {
      station_id: null,
      station_name: null,
    },
    allFoodCategory: false,
    phoneNumber: null,
    printText: "Print",
    // Order Details End

    // Cinema Details
    CinemaDetails: [],
    // Cinema Details End

    //
    OrderId: null,
    userDetails: null,
    stockDeduction: null,
    stockDeductionConcession: null,
    //

    //
    ChangeAmount: 0,
    cashdata: [],
    cashSelectedList: [],
    cashInputValue: 0,
    //
    FnBItemsModule: true,
    showFnBOrderDetails: false,
    isFnbDataLoading: true,
    fnbItemList: [],
    fnbCategories: [],
    fnbMoreCategories: [],
    fnbSubCategories: [],

    // Selected
    selectedFnbItemList: [],
    selectedFnBItemsTotalPrice: 0,
    //
    fnbPayload: {
      cinema_id: null,
      // Require on condition
      search: "",
      isVeg: "N",
      isEgg: "N",
      category: null,
      subCategory: null,
      isCombo: false
    },
    currency: {
      curr_code: null,
      curr_name: null,
      curr_id: null
    },

    // FnB item (Tax) Additional setting Price.
    additionalTaxList: [],
    totalAdditionalTaxes: 0,

    // Final Checkout
    paymentTypes: {
      cashPayments: true,
      creditNDebit: false,
      cashless: false,
      splitPayments: false,
      couponNPromotions: false,
      vouchers: false,
      loyaltyCard: false
    },

    paging: {},

    // Only For Object Use:
    itemAdditionObject: {
      charge_type_id: null,
      ct_name: null,
      ct_id: null,
      ct_code: null,
      fnb_price_id: null,
      fpas_charge_value: null,
      fpas_is_percentage: null,
      price: null,
      taxPrice: null
    },
    BoxofficeCalculator: false,

    //Electron F&B Show
    ShowFnB: false,
    FnBEjsData: {},
    multifnbFlag: false,
    AddedItem: {}, //for show popup for multi fnb with item details,
    isBOFnBSelected: false,
    AlternateItems: [],
    prevItemId: null,
    prevQty: 1,
    FnbLoyalityProgram: 0,
    combineLoyaltyAmount: 0,
    pointsEarnedAfterFnbBooking: 0,
    pointsEarnedAfterBoxOfficeBooking: 0,
    multiCurrencyId: null,
    multiCurrencyConversionRate: null,
    multiCurrencyAmount: null,
    global_curr_id: null,
    fnbItemsLength: 0,
    AllFnbCategoriesWithFilter: [],
    ft_reservation_id: randomAlphaNumeric(),
    fnb_reservation_id_check_array: []
  };
}
const state = initialState();

// const state = {
//     // Order Details
//     phoneNumber: null,
//     printText: 'Print',
//     // Order Details End

//     // Cinema Details
//     CinemaDetails: [],
//     // Cinema Details End

//     //
//     OrderId: null,
//     userDetails: null,
//     stockDeduction: null,
//     stockDeductionConcession: null,
//     //

//     //
//     ChangeAmount: 0,
//     cashdata: [],
//     cashSelectedList: [],
//     cashInputValue: 0,
//     //
//     FnBItemsModule: true,
//     showFnBOrderDetails: false,
//     fnbItemList: [],
//     fnbCategories: [],
//     fnbMoreCategories: [],
//     fnbSubCategories: [],

//     // Selected
//     selectedFnbItemList: [],
//     selectedFnBItemsTotalPrice: 0,
//     //
//     fnbPayload: {
//         cinema_id: null,
//         // Require on condition
//         search: '',
//         isVeg: 'N',
//         isEgg: 'N',
//         category: null,
//         subCategory: null,
//         isCombo: false,
//     },
//     currency: {
//         curr_code: null,
//         curr_name: null,
//         curr_id: null,
//     },

//     // FnB item (Tax) Additional setting Price.
//     additionalTaxList: [],
//     totalAdditionalTaxes: 0,

//     // Final Checkout
//     paymentTypes: {
//         cashPayments: true,
//         creditNDebit: false,
//         cashless: false,
//         splitPayments: false,
//         couponNPromotions: false,
//         vouchers: false,
//         loyaltyCard: false
//     },

//     paging: {},

//     // Only For Object Use:
//     itemAdditionObject: {
//         charge_type_id: null,
//         ct_name: null,
//         ct_id: null,
//         ct_code: null,
//         fnb_price_id: null,
//         fpas_charge_value: null,
//         fpas_is_percentage: null,
//         price: null,
//         taxPrice: null,
//     }
// }

const mutations = {
  SET_FNB_ITEM_LENGTH: (state, payload) => {
    let fnbLength = payload.Records.length;
    console.log("payload", payload);
    console.log("payload.Records.length", payload.Records.length);
    console.log("fnbLength SET_FNB_ITEM_LENGTH", fnbLength);
    state.fnbItemsLength = fnbLength;
  },
  SET_COMBINE_LOYALITY: (state, payload) => {
    state.combineLoyaltyAmount = payload;
  },
  SET_AMOUNT_LOYALITY: (state, payload) => {
    state.FnbLoyalityProgram = payload;
  },
  SET_BO_FNB_SELECTED: (state, payload) => {
    state.isBOFnBSelected = payload;
  },
  SET_MULTI_FNB_FLAG: (state, payload) => {
    state.multifnbFlag = payload;
  },
  SET_ADDED_ITEM_FLAG: (state, payload) => {
    state.AddedItem = payload;
  },
  SET_FNB_RESERVATION: (state, payload) => {
    state.fnb_reservation_id_check_array.push(payload);
  },
  RESET_FNB_RESERVATION: (state, payload) => {
    state.fnb_reservation_id_check_array = [];
  },
  RESET_ALL_FNB_RESERVATION: (state, payload) => {
    console.log('CALLED RESET_ALL_FNB_RESERVATION');
    state.fnb_reservation_id_check_array = [];
    state.ft_reservation_id = randomAlphaNumeric();
  },
  CLEAR_ITEM_DETAILS: (state, payload) => {
    state.AddedItem = {};
  },
  SET_MORE_QUANTITY: (state, payload) => {
    let objIndex = state.selectedFnbItemList.findIndex(
      obj => obj.item_id == payload.ItemDetails.item_id
    );

    if (objIndex < 0) {
      payload.ItemDetails["quantity"] = parseInt(payload.moreQuantity);
      payload.ItemDetails["customizations"] = [];

      if(payload.ItemDetails.hasOwnProperty('combo_pack') && payload.ItemDetails.combo_pack.length > 0) {
        payload.ItemDetails.combo_pack.map((x) => {
          x['quantity'] = parseInt(parseInt(x['quantity'])) * parseInt(payload.moreQuantity)
          x.combo_items.forEach((y) => {
            if(y.quantity > 0) {
              y['quantity'] = parseInt(parseInt(y['quantity'])) * parseInt(payload.moreQuantity)
            }
          })
        })
      }

      state.selectedFnbItemList.push(payload.ItemDetails);
    } else {
      state.selectedFnbItemList[objIndex]["quantity"] += parseInt(
        payload.moreQuantity
      );

      let fnbItem = state.selectedFnbItemList[objIndex]
      let oldQuantity = state.selectedFnbItemList[objIndex]["quantity"] - parseInt(payload.moreQuantity)
      if(fnbItem.hasOwnProperty('combo_pack') && fnbItem.combo_pack.length > 0) {
        fnbItem.combo_pack.map((x) => {
          x['quantity'] = parseInt(parseInt(x['quantity'])/parseInt(oldQuantity)) * parseInt(state.selectedFnbItemList[objIndex]["quantity"])
          x.combo_items.forEach((y) => {
            if(y.quantity > 0) {
              y['quantity'] = parseInt(parseInt(y['quantity'])/parseInt(oldQuantity)) * parseInt(state.selectedFnbItemList[objIndex]["quantity"])
            }
          })
        })
      }

    }
  },
  SET_MULTI_CURR_ID: (state, payload) => (state.multiCurrencyId = payload),
  SET_MULTI_CURR_CONVERSION_RATE: (state, payload) =>
    (state.multiCurrencyConversionRate = payload),
  SET_MULTI_CURR_AMOUNT: (state, payload) =>
    (state.multiCurrencyAmount = payload),
  GLOBAL_CURR_ID: (state, payload) => (state.global_curr_id = payload),
  RESET_MULTI_CURR_DATA: (state, payload) => {
    (state.multiCurrencyId = null),
      (state.multiCurrencyConversionRate = null),
      (state.multiCurrencyAmount = null);
  },
  CLEAR_IDS_FOR_FNB: (state, payload) => {
    state.FnBEjsData = {};
  },
  SET_FTID: (state, payload) => {
    state.FnBEjsData.ft_id = payload.ft_id;
  },
  SET_SELECTED_STATION: (state, payload) => {
    Object.keys(state.selectedStation).map((key) => {
      state.selectedStation[key] = payload.selectedStation && payload.selectedStation[key] ? payload.selectedStation[key] : null
    })
  },
  SET_PICKUP_DETAILS: (state, payload) => {
    state.selectedFnbItemList = [];
    state.additionalTaxList = [];

    state.OrderId = payload.MainDetails[0].order_code;
    state.selectedFnbItemList = payload.SubDetails;
    state.selectedFnBItemsTotalPrice = payload.MainDetails[0].ft_net_amount;
    state.totalAdditionalTaxes = 0;

    payload.SubDetails.map(x => {
      x.additionalTaxes.map(y => {
        state.totalAdditionalTaxes += y.totalTax;
        state.additionalTaxList.push(y);
      });
    });
  },
  CLEAR_PICKUP_DETAILS: (state, payload) => {
    state.selectedFnbItemList = [];
    state.additionalTaxList = [];
    state.totalAdditionalTaxes = 0;
    state.selectedFnBItemsTotalPrice = 0;
    state.OrderId = "";
  },
  CHANGE_TEXT: (state, payload) => {
    state.printText = "Reprint";
  },
  SET_CASH_CALCULATOR: (state, payload) => {
    state.cashdata = [];
    payload.map(x => {
      x["count"] = 0;
      x["value"] = parseFloat(x.denomination_value);
      state.cashdata.push(x);
      // console.log('state.cashdata :', state.cashdata);
    });
  },
  SET_CHANGE_AMOUT: (state, payload) => {
    state.ChangeAmount = 0;
    // state.ChangeAmount = state.cashInputValue;
    state.cashSelectedList.map(x => {
      state.ChangeAmount += parseFloat(x.value) * parseFloat(x.count);
      state.cashInputValue = parseFloat(state.ChangeAmount);
      // console.log('state.cashInputValue SET CHANGE AMOUT :', state.cashInputValue);
    });
  },
  SET_FNB_STATIONS: (state, payload) => {
    state.FnbStations = payload;
  },
  SET_MULTICURR_CHANGE: (state, payload) => {
    state.ChangeAmount = state.cashInputValue;
  },
  SET_INPUT_AMOUNT: (state, payload) => {
    state.cashInputValue = parseFloat(payload);
  },
  SET_SELECTED_CASH: (state, { Cash, ...payload }) => {
    let listIndex = state.cashSelectedList.findIndex(
      x => x.denomination_value == Cash.denomination_value
    );
    if (listIndex > -1) {
      state.cashSelectedList[listIndex].count++;
    } else if (listIndex < 0) {
      state.cashSelectedList.push({
        ...Cash,
        count: 1
      });
    }
  },
  SWTICH_FNB_MODULE: (state, { name, ...payload }) => {
    state[name] = !state[name];
  },
  // Tax Cal
  SET_FNB_ADDITIONAL_TAX: (state, { listIndex, additionalTaxes }) => {
    state.selectedFnbItemList[listIndex]["additionalTaxes"] = additionalTaxes;
  },
  // Tax Cal End
  // SET CINEMA
  SET_CINEMA_DETAILS: (state, payload) => {
    state.CinemaDetails = payload;
  },
  // END
  SET_FNB_ITEMS: (state, payload) => {
    state.fnbItemList = payload.Records ? payload.Records.sort((a,b) => {
      if (a.fc_order && b.fc_order)
        return a.fc_order - b.fc_order
      else
        return 1
    }) : payload.Records
  },
  SET_LOADER: (state, payload) => {
    state.isFnbDataLoading = payload;
  },
  SET_FNB_CINEMA: (state, payload) => {
    state.fnbPayload.cinema_id = payload.cinemaId;
    state.userDetails = payload.userDetails;
    state.stockDeduction = payload.stockDeduction;
    state.stockDeductionConcession = payload.stockDeductionConcession;
  },
  SET_CURRENCY_DETAILS: (state, payload) => {
    state.currency = {
      ...state.currency,
      ...payload
    };
  },
  SET_FNB_CATEGORIES: async (state, payload) => {
    state.fnbCategories = [];
    const defaultFc = payload.Categories.filter((x) => x.fc_id == store.getters.DEFAULT_SELECTED_FOOD_CATEGORY)
    if(defaultFc && defaultFc.length > 0) {
      state.fnbPayload.category = defaultFc[0].fc_id || null;
        store.dispatch('setOnFnBPayloads', {
          event: null,
          name: 'category',
          fc_id: defaultFc[0].fc_id || null,
        })
    }
    for (let i = 0; i < payload.Categories.length; i++) {
      const element = payload.Categories[i];
      if (state.fnbCategories.length < 30000) {
        state.fnbCategories.push(element);
      } else {
        if(!state.fnbMoreCategories.some(fnb => fnb['fc_id'] === element['fc_id'])) {
          state.fnbMoreCategories.push(element);
        }
        }
      }

  },
  SET_ALL_FNB_CATEGORIES: async (state, payload) => {
    state.AllFnbCategoriesWithFilter = payload
  },
  SET_FNB_SUB_CATEGORIES: (state, payload) => {
    state.fnbSubCategories = payload.Categories;
  },
  SET_FNB_SELECTED_SUB_CATEGORY: (state, payload) => {
    state.fnbPayload.subCategory = payload;
  },
  SET_SEARCH_VALUES: (state, payload) => {
    state.fnbPayload.search = payload;
  },
  SET_CATEGORY_VALUES: (state, payload) => {
    state.fnbPayload.category = payload;
  },
  ALL_FOOD_CATEGORY: (state, payload) => {
    state.allFoodCategory = payload;
  },
  ADD_ON_FNB_ITEMS: (state, payload) => {
    let obj = {
      quantity: payload.quantity || 1,
      ...payload,
      customizations: []
    };
    // let listIndex = state.selectedFnbItemList.findIndex(x => x.fc_id == payload.fc_id && x.fc_parent_id === payload.fc_parent_id);
    let listIndex = state.selectedFnbItemList.findIndex(
      x => x.item_id == payload.item_id
    );
    if (listIndex > -1) {
      console.log("object 1:");
      if(payload.hasOwnProperty('add_custom_quantity') && payload.add_custom_quantity == 'Y') {
        state.selectedFnbItemList[listIndex].quantity = payload.quantity;
      } else {
        state.selectedFnbItemList[listIndex].quantity++;
      }
      let fnbItem = state.selectedFnbItemList[listIndex];
      if(fnbItem.hasOwnProperty('combo_pack') && fnbItem.combo_pack.length > 0) {
        let finalComboArray = [];
        state.selectedFnbItemList[listIndex].combo_pack.map((x) => {
          x['quantity'] = parseFloat(parseFloat(x['quantity'])/parseFloat(state.selectedFnbItemList[listIndex].quantity - 1)) * (parseFloat(state.selectedFnbItemList[listIndex].quantity))
          x.combo_items.forEach((y) => {
            if(y.quantity > 0) {
              y['quantity'] = parseFloat(parseFloat(y['quantity'])/parseFloat(state.selectedFnbItemList[listIndex].quantity - 1)) * (parseFloat(state.selectedFnbItemList[listIndex].quantity))
              finalComboArray.push(y)
            }
          })
        })
        state.selectedFnbItemList[listIndex]['final_combo_array'] = _.cloneDeep(finalComboArray)
      }

    } else if (listIndex < 0) {
      console.log("object 2:");
      // state.ShowFnB = true;
      state.selectedFnbItemList.push(obj);
    }
  },
  REMOVE_ON_FNB_ITEMS: (state, payload) => {
    if (payload.hasOwnProperty("index") && String(payload.index).length > 0) {
      let fnbItem = state.selectedFnbItemList[payload.index]
      if(fnbItem.hasOwnProperty('combo_pack') && fnbItem.combo_pack && fnbItem.combo_pack.length > 0) {
        let finalComboArray = [];
        state.selectedFnbItemList[payload.index].combo_pack.map((x) => {
          x['quantity'] = parseFloat(parseFloat(x['quantity'])/parseFloat(state.selectedFnbItemList[payload.index].quantity))
          x.combo_items.forEach((y) => {
            if(y.hasOwnProperty('selected') && y.selected) {
              y['quantity'] = parseFloat(parseFloat(y['quantity'])/parseFloat(state.selectedFnbItemList[payload.index].quantity))
              finalComboArray.push(y)
            } else {
              y['quantity'] = 0
            }
          })
        })
        state.selectedFnbItemList[payload.index]['final_combo_array'] = _.cloneDeep(finalComboArray)
      }
      state.selectedFnbItemList.splice(payload.index, 1);
    }

  },
  INCREASE_FNB_ITEM: (state, payload) => {
    if (payload.hasOwnProperty("index") && String(payload.index).length > 0)
      state.selectedFnbItemList[payload.index].quantity++;
      let fnbItem = state.selectedFnbItemList[payload.index];
      if(fnbItem.hasOwnProperty('combo_pack') && fnbItem.combo_pack.length > 0) {
        let finalComboArray = [];
        state.selectedFnbItemList[payload.index].combo_pack.map((x) => {
          x['quantity'] = parseFloat(parseFloat(x['quantity'])/parseFloat(state.selectedFnbItemList[payload.index].quantity - 1)) * (parseFloat(state.selectedFnbItemList[payload.index].quantity))
          x.combo_items.forEach((y) => {
            if(y.quantity > 0) {
              y['quantity'] = parseFloat(parseFloat(y['quantity'])/parseFloat(state.selectedFnbItemList[payload.index].quantity - 1)) * (parseFloat(state.selectedFnbItemList[payload.index].quantity))
              finalComboArray.push(y)
            }
          })
        })
        state.selectedFnbItemList[payload.index]['final_combo_array'] = _.cloneDeep(finalComboArray)
      }
  },
  DECREASE_FNB_ITEM: (state, payload) => {
    if (
      payload.hasOwnProperty("index") &&
      String(payload.index).length > 0 &&
      state.selectedFnbItemList[payload.index].quantity > 0
    ) {

      let fnbItem = state.selectedFnbItemList[payload.index];
      if(fnbItem.hasOwnProperty('combo_pack') && fnbItem.combo_pack.length > 0) {
        let finalComboArray = [];
        state.selectedFnbItemList[payload.index].combo_pack.map((x) => {
          if(x.quantity > parseFloat(parseFloat(x['quantity'])/parseFloat(state.selectedFnbItemList[payload.index].quantity))) {
            x['quantity'] = parseFloat(parseFloat(x['quantity'])/parseFloat(state.selectedFnbItemList[payload.index].quantity)) * (parseFloat(state.selectedFnbItemList[payload.index].quantity - 1))
            x.combo_items.forEach((y) => {
              if(y.quantity > parseFloat(parseFloat(x['quantity'])/parseFloat(state.selectedFnbItemList[payload.index].quantity))) {
                y['quantity'] = parseFloat(parseFloat(y['quantity'])/parseFloat(state.selectedFnbItemList[payload.index].quantity)) * (parseFloat(state.selectedFnbItemList[payload.index].quantity - 1))
                finalComboArray.push(y)
              }
            })
          }
        })
        state.selectedFnbItemList[payload.index]['final_combo_array'] = _.cloneDeep(finalComboArray)
      }
      state.selectedFnbItemList[payload.index].quantity--;
    }

    if (
      payload.hasOwnProperty("index") &&
      String(payload.index).length > 0 &&
      state.selectedFnbItemList[payload.index].quantity === 0
    ) {
      store.dispatch(
        "REMOVE_CUSTOMIZATION_FROM_ITEM",
        state.selectedFnbItemList[payload.index]
      );
      state.selectedFnbItemList.splice(payload.index, 1);
    }
  },
  // DECREASE_FNB_ITEM: (state, payload) => {
  //   if (payload.hasOwnProperty('index') && String(payload.index).length > 0 && state.selectedFnbItemList[payload.index].quantity > 0) state.selectedFnbItemList[payload.index].quantity--;
  //   if (payload.hasOwnProperty('index') && String(payload.index).length > 0 && state.selectedFnbItemList[payload.index].quantity === 0) state.selectedFnbItemList.splice(payload.index, 1);
  // },
  CALCULATE_FNB_ITEMS_PRICE: async (state, payload) => {
    state.selectedFnBItemsTotalPrice = 0;
    state.totalAdditionalTaxes = 0;
    if (state.selectedFnbItemList.length === 0) state.additionalTaxList = [];
    let Promises = state.selectedFnbItemList.map((x, index) => {
      // state.selectedFnBItemsTotalPrice += (x.fp_total_amount * x.quantity);
      state.selectedFnBItemsTotalPrice += x.fp_amount * x.quantity;
      if (x.hasOwnProperty("additionalTaxes") && x.additionalTaxes.length > 0) {
        x.additionalTaxes.map(tax => {
          // console.log('tax.frcs_amount :', tax.frcs_amount);
          let listIndex = state.additionalTaxList.findIndex(
            z => z.ct_id == tax.ct_id
          );
          // state.totalAdditionalTaxes += tax.fpas_charge_value * x.quantity;
          state.totalAdditionalTaxes += tax.frcs_amount * x.quantity;
          if (listIndex > -1) {
            // x.fc_id === state.additionalTaxList[listIndex].fc_id ? state.additionalTaxList[listIndex].totalTax = tax.fpas_charge_value * x.quantity : state.additionalTaxList[listIndex].totalTax += tax.fpas_charge_value * x.quantity;
            // x.fc_id === state.additionalTaxList[listIndex].fc_id ? state.additionalTaxList[listIndex].totalTax = tax.frcs_amount * x.quantity : state.additionalTaxList[listIndex].totalTax += tax.frcs_amount * x.quantity;
            x.item_id === state.additionalTaxList[listIndex].item_id
              ? (state.additionalTaxList[listIndex].totalTax =
                tax.frcs_amount * x.quantity)
              : (state.additionalTaxList[listIndex].totalTax +=
                tax.frcs_amount * x.quantity);
          } else if (listIndex < 0) {
            state.additionalTaxList.push({
              fc_id: x.fc_id,
              quantity: x.quantity,
              totalTax: tax.frcs_amount * x.quantity,
              ...tax
            });
          }
          return tax;
        });
      }
      return x;
    });
    // await Promise.all(Promises);
    // state.additionalTaxList.map(({ totalTax }) => { state.totalAdditionalTaxes += totalTax });
  },
  SHOW_FNB_DETAILS: (state, payload) => {
    const h = global.vmVue.$createElement;
    // Using HTML string
    // const titleVNode = h('div', { class: ['text-center w-100'], domProps: { innerHTML: ''  } })
    // More complex structure
    const messageVNode = h(
      "div",
      {
        class: ["foobar"]
      },
      [
        // h('h5', { class: ['text-center border-bottom pb-2'], domProps: { innerHTML: payload.recipe_name } }),
        h(
          "p",
          {
            class: ["text-center"]
          },
          [payload.item_description]
        )
      ]
    );
    // We must pass the generated VNodes as arrays
    global.vmVue.$bvModal.msgBoxOk([messageVNode], {
      size: "sm",
      // title: [titleVNode],
      title: payload.recipe_name,
      // okTitle: 'Cancel',
      buttonSize: "sm",
      hideHeaderClose: true,
      centered: true
    });
  },
  IS_VEG_HANDLER: (state, payload) => {
    state.fnbPayload.isVeg = payload;
  },
  IS_EGG_HANDLER: (state, payload) => {
    state.fnbPayload.isEgg = payload;
    console.log("state.fnbPayload.isEgg : ", state.fnbPayload.isEgg);
  },
  REMOVE_SELECTED_FNB_ITEMS: (state, payload) => {
    console.log('REMOVING SELECTED FNB ITEMS');
    state.selectedFnbItemList = [];
    state.selectedFnBItemsTotalPrice = 0;
    state.ft_reservation_id = randomAlphaNumeric();
    state.fnb_reservation_id_check_array = [];
  },
  RESET_FNB: (state, payload) => {
    console.log('RESETTING FNB STORE');
    store.dispatch("onSetAndSendLog", {
      action: `Cancel button was selected.`,
      page_name: "box office fnb",
      api_name: ""
    });
    state.FnBItemsModule = true;
    state.showFnBOrderDetails = false;
    state.printText = "Print";
    state.allFoodCategory = false;
    state.fnbSubCategories = [];
    // state.fnbItemList = []
    state.selectedFnbItemList = state.selectedFnbItemList.filter(x => {
      return x.is_package_ticket == "Y";
    });
    // state.selectedFnbItemList = [];
    state.additionalTaxList = [];
    state.totalAdditionalTaxes = 0;
    state.selectedStation = {
      station_id: null,
      station_name: null,
    };
    //
    state.OrderId = null;
    state.phoneNumber = null;
    state.pointsEarnedAfterFnbBooking = 0;
    state.pointsEarnedAfterBoxOfficeBooking = 0;
    //

    state.selectedFnBItemsTotalPrice = 0;
    state.ft_reservation_id = randomAlphaNumeric();
    state.fnb_reservation_id_check_array = [];
    let obj = state.fnbPayload;
    state.fnbPayload = {
      ...obj,
      search: "",
      isVeg: "N",
      isEgg: "N",
      category: window.localStorage.getItem("dflt_fc_id") ? JSON.parse(window.localStorage.getItem("dflt_fc_id")) : null,
      subCategory: null,
      isCombo: false
    };
  },
  RESET_SELECTED_CASH: (state, payload) => {
    state.ChangeAmount = 0;
    state.cashInputValue = 0;
    state.cashSelectedList = [];
    if (!state.FnBItemsModule && state.selectedFnbItemList.length == 0)
      state.FnBItemsModule = !state.FnBItemsModule;
  },

  //
  CHANGE_PAYMENT_MODE: (state, payload) => {
    Object.keys(state.paymentTypes).map(x => {
      if (x == payload) {
        state.paymentTypes[x] = !state.paymentTypes[x];
      } else {
        state.paymentTypes[x] = false;
      }
    });
  },
  ON_PHONE_NUMBER_HANDLER: (state, payload) => {
    state.phoneNumber = payload;
  },

  //
  ON_SET_TRANSACTION_ID: (state, payload) => {
    state.OrderId = payload.orderCode;
  },
  ON_RESET_FNB_STORE_STATE: (state, payload) => {
    // state = initialState();
    const s = initialState();
    Object.keys(s).forEach(key => {
      if (key != "fnbItemsLength") {
        state[key] = s[key];
      }
    });
  },
  SET_BoxOfficeCalCulator_Flag: (state, payload) => {
    state.BoxofficeCalculator = payload;
  },
  SET_FloatAmountValue_Flag: (state, payload) => {
    state.FlatAmountValue = payload;
    // // console.log('state.FlatAmountValue :', state.FlatAmountValue);
  },
  ADD_CUSTOMIZATION: (state, payload) => {
    let fnbItemIndex = state.selectedFnbItemList.findIndex(x => {
      return x.item_id == payload.fnb_id;
    });
    if (fnbItemIndex > -1) {
      let obj = {
        item_id: payload.customization.customization_id,
        item_name: payload.customization.item_name,
        quantity: 1,
        customized_for_fnb_id: payload.customization.fnb_id
      };
      state.selectedFnbItemList[fnbItemIndex]["customizations"].push(obj);
    }
  },
  REMOVE_CUSTOMIZATION: (state, payload) => {
    let fnbItemIndex = state.selectedFnbItemList.findIndex(x => {
      return x.item_id == payload.item_id;
    });
    if (fnbItemIndex > -1) {
      let customizationIndexId = state.selectedFnbItemList[fnbItemIndex][
        "customizations"
      ].findIndex(y => {
        return y.item_id == payload.customization_id;
      });
      if (customizationIndexId > -1) {
        state.selectedFnbItemList[fnbItemIndex]["customizations"].splice(
          customizationIndexId,
          1
        );
      }
    }
  },
  SET_PREV_ITEM_ID: (state, payload) => {
    state.prevItemId = payload.item_id;
    state.prevQty = payload.qty;
  },
  SET_ALTERNATE_ITEMS: (state, payload) => {
    state.AlternateItems = payload;
  },
  SET_EARNED_POINTS_AFTER_FNB_BOOKING: (state, payload) => {
    state.pointsEarnedAfterFnbBooking = payload;
  },
  SET_EARNED_POINTS_AFTER_BOX_OFFICE_BOOKING: (state, payload) => {
    state.pointsEarnedAfterBoxOfficeBooking = payload;
  }
};

const actions = {
  onCloseClearIDsforFnb: async (
    { dispatch, commit, state },
    { ...payload }
  ) => {
    await commit("CLEAR_IDS_FOR_FNB");
  },
  OnPOSLogin: ({ commit }, payload) => {
    commit("SET_BoxOfficeCalCulator_Flag", payload);
  },
  OnFloatValue: ({ commit }, payload) => {
    commit("SET_FloatAmountValue_Flag", payload);
  },
  onResetFnBStoreState: async ({ dispatch, commit, state }, { ...payload }) => {
    await commit("ON_RESET_FNB_STORE_STATE");
    await store.dispatch('onResetEmployeeDetails')
  },
  resetFnbReservation: async ({ dispatch, commit, state }, { ...payload }) => {
    await commit("RESET_ALL_FNB_RESERVATION")
  },
  onSwtichModule: async ({ dispatch, commit, state }, payload) => {
    await store.dispatch("resetLoyaltyData");
    await store.dispatch("resetCashCardData");
    await store.dispatch("resetCustomerDetails");
    console.log("object--------------- :", payload);
    if (payload.name === "FnBItemsModule") {
      await commit("RESET_SELECTED_CASH", payload);
      if (!store.getters.getSelectedOffer || Object.keys(store.getters.getSelectedOffer).length == 0) {
        dispatch('ResetTransactionComment')
      }
    }
    if (payload.name === "showFnBOrderDetails" && state[payload.name]) {
      await dispatch("onResetFnBHandler", payload);
    } else await commit("SWTICH_FNB_MODULE", payload);

  },
  fetchFnbStations: ({ dispatch, commit, state }, payload) => {
    PosFnbService.GetFnbStations()
      .then(response => {
        const { data } = response;
        if (data && data.status && data.Records.length > 0) {
          commit("SET_FNB_STATIONS", data.Records);
        } else {
          // Show Error Message:
          console.log("data.message :", data.message);
        }
      })
      .catch(error => {
        // Catch Error:
        console.log("Catch Error on getActiveScreenByCinemaId :", error);
      });
  },
  fetchCurrencyCode: ({ dispatch, commit, state }, { curr_id }) => {
    let payload = {
      tableName: "ms_currencies",
      curr_is_active: "Y",
      curr_id
    };
    MasterService.GetActiveList(payload)
      .then(response => {
        const { data } = response;
        if (data && data.status && data.Records.length > 0) {
          console.log("data.Records[0] :", data.Records[0]);
          commit("SET_CURRENCY_DETAILS", data.Records[0] || {});
        } else {
          // Show Error Message:
          console.log("data.message :", data.message);
        }
      })
      .catch(error => {
        // Catch Error:
        console.log("Catch Error on getActiveScreenByCinemaId :", error);
      });
  },
  fetchCinemaDetails: ({ dispatch, commit, state }, payload) => {
    let body = {
      tableName: "ms_cinemas",
      cine_is_active: "Y",
      cine_id: payload
    };
    MasterService.GetActiveList(body)
      .then(response => {
        const { data } = response;
        if (data && data.status && data.Records.length > 0) {
          commit("SET_CINEMA_DETAILS", data.Records);
          let mobile_code = data.Records[0].cine_mobile_code;
          store.commit("SET_CUST_MOB_CODE", mobile_code);
        } else {
          // Show Error Message:
          Vue.toasted.show(data.message || "Opps! Something went wrong");
        }
      })
      .catch(error => {
        // Catch Error:
        console.log("Catch Error on Cinema List in FnB Store :", error);
        Vue.toasted.show(
          "Sorry! Something went wrong. kindly contact your administrator"
        );
      });
  },
  fetchFnBCategories: ({ dispatch, commit, state }, payload) => {
    PosFnBService.GetFnBCategories(payload)
      .then(response => {
        const { data } = response;
        if (data && data.status && data.Records) {
          commit("SET_FNB_CATEGORIES", {
            Categories: data.Records || []
          });
          commit("SET_ALL_FNB_CATEGORIES", {
            Categories: data.Records || []
          });
        } else {
          Vue.toasted.show(data.message || "Opps! Something went wrong");
        }
      })
      .catch(error => {
        console.log("Catch Error on FnBStore fetchFnBItems", error);
      });
  },
  fetchFnBSubCategories: (
    { dispatch, commit, state },
    { parentid, ...payload }
  ) => {
    if (parentid !== null) {
      PosFnBService.GetFnBSubCategories({
        parentid
      })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records) {
            // console.log('data :', data);
            commit("SET_FNB_SUB_CATEGORIES", {
              Categories: data.Records || []
            });
          } else {
            Vue.toasted.show(data.message || "Opps! Something went wrong");
          }
        })
        .catch(error => {
          console.log("Catch Error on FnBStore fetchFnBItems", error);
        });
    } else {
      commit("SET_FNB_SUB_CATEGORIES", {
        Categories: []
      });
    }
  },
  fetchFnBItems: ({ dispatch, commit, state }, payload) => {
    commit("SET_LOADER", true);
    let defaultFc_id = null;

    if (window.localStorage.getItem("dflt_fc_id")) {
      defaultFc_id = JSON.parse(
        window.localStorage.getItem("dflt_fc_id")
      );

      if(state.AllFnbCategoriesWithFilter.length > 0) {
       let categoryArray =  state.AllFnbCategoriesWithFilter.filter((x) => x.fc_id == defaultFc_id);
        if(categoryArray && categoryArray.length > 0) {
          defaultFc_id = categoryArray[0].fc_id
        } else {
          defaultFc_id = null;
        }
      }
    }

    if(state.allFoodCategory) {
      defaultFc_id = null
    }

    let userInfo = authenticationService.get("USINFO");

    let cinemaId = state.fnbPayload.cinema_id ? state.fnbPayload.cinema_id : userInfo.cinema_id

    let body = {
      ...state.fnbPayload,
      cinema_id: cinemaId,
      pos_user_id: authenticationService.get("USINFO").user_id,
      reservation_id: store.getters.reservationId || null,
      category:
        state.fnbPayload.subCategory && state.fnbPayload.subCategory.length > 0
          ? state.fnbPayload.subCategory.toString()
          : state.fnbPayload.category ? state.fnbPayload.category : defaultFc_id ? defaultFc_id : null,
      isVeg: state.fnbPayload.isVeg === "N" ? "" : state.fnbPayload.isVeg,
      isEgg:
        state.fnbPayload.isVeg === "N"
          ? ""
          : state.fnbPayload.isVeg === "Y" && state.fnbPayload.isEgg === "N"
            ? ""
            : state.fnbPayload.isEgg
    };
    // console.log('FnBList body :', body);

    PosFnBService.GetFnBList(body)
      .then(response => {
        const { data } = response;
        commit("SET_LOADER", false);
        if (data && data.status && data.Records) {
          commit("SET_FNB_ITEMS", data.Records || []);
          console.log("SET_FNB_ITEMS", data.Records);
          console.log("SET_FNB_ITEM_LENGTH", data.Records.Records.length);
          commit("SET_FNB_ITEM_LENGTH", data.Records);
        } else {
          commit("SET_FNB_ITEMS", []);
          Vue.toasted.show(data.message || "Opps! Something went wrong");
          if(data.hasOwnProperty('notAuthorized') && data.notAuthorized) {
            store.dispatch('LogoutUserTokenExpired')
          }
        }
      })
      .catch(error => {
        commit("SET_LOADER", false);
        console.log("Catch Error on FnBStore fetchFnBItems", error);
      }).finally(() => {
        store.dispatch('fetchMissingVendorRatesItems', {cinema_id: cinemaId})
        commit("SET_LOADER", false);
      })
  },
  fetchMissingVendorRatesItems: ({ dispatch, commit, state }, payload) => {
    let loader = Vue.$loading.show();
    let body = {
      cinema_id: payload.cinema_id
    }
    if(payload.hasOwnProperty('item_id') && payload.item_id) {
      body['item_id'] = payload.item_id
    }
    PosFnBService.GetFnbCheckVendorRates(body)
    .then((response) => {
      const { data } = response;
      if(data.status && data.Records && data.Records.length > 0) {
        if(store.getters.fnbItems && store.getters.fnbItems.length > 0) {
          let tempArr = _.cloneDeep(store.getters.fnbItems);
          data.Records.forEach((x) => {
            let findIndex = tempArr.findIndex((i) => i.item_id == x.item_id);
            if(findIndex > -1) {
              tempArr[findIndex]['availableInVendorRates'] = 'N'
            }
          })
          commit("SET_FNB_ITEMS", {Records: [...tempArr]});
        }
      }
    }).catch((err) => {
      console.log('Error:', err);
      loader.hide();
    }).finally(() => {
      loader.hide();
    })
  },
  fetchFnBAdditionalPrice: ({ dispatch, commit, state }, payload) => {
    console.log("payload :", payload);
    PosFnBService.GetFnBAdditionalCharges({
      // fp_id: payload.fp_id
      item_id: payload.item_id
    })
      .then(async response => {
        const { data } = response;
        if (data && data.status && data.Records) {
          // let listIndex = state.selectedFnbItemList.findIndex(x => x.fc_id == payload.fc_id && x.fc_parent_id === payload.fc_parent_id);
          if(state.selectedFnbItemList && state.selectedFnbItemList.length > 0) {
            let listIndex = state.selectedFnbItemList.findIndex(
              x => x.item_id == payload.item_id
            );
            await commit("SET_FNB_ADDITIONAL_TAX", {
              listIndex,
              additionalTaxes: data.Records
            });
            await commit("CALCULATE_FNB_ITEMS_PRICE", payload);
          }
        } else {
          Vue.toasted.show(data.message || "Opps! Something went wrong");
        }
      })
      .catch(error => {
        console.log('ERROR fetchFnBAdditionalPrice', error);
        Vue.toasted.show(
          "Catch Error on FnBStore fetchFnBAdditionalPrice",
          error
        );
      });
  },
  setOnFnBPayloads: async (
    { dispatch, commit, state },
    { event, ...payload }
  ) => {
    if (payload.name === "search") {
      commit("SET_SEARCH_VALUES", event.target.value);
    } else if (payload.name === "category") {
      await commit("SET_CATEGORY_VALUES", payload.fc_id);
      if(payload.hasOwnProperty('allCategory')) {
        await commit("ALL_FOOD_CATEGORY", true);
      }
      await dispatch("fetchFnBItems");
      await dispatch("fetchFnBSubCategories", {
        parentid: payload.fc_id
      });
    } else if (payload.name === "clearsearch") {
      await commit("SET_SEARCH_VALUES", "");
      await dispatch("fetchFnBItems");
    } else if (payload.name === "isVeg") {
      // console.log('IsVeg Payload :', payload.name);
      await commit("IS_VEG_HANDLER", event);
      await dispatch("fetchFnBItems");
    } else if (payload.name === "isEgg") {
      // console.log('IsEgg Payload :', payload.name);
      await commit("IS_EGG_HANDLER", event);
      await dispatch("fetchFnBItems");
    } else if (payload.name === "subCategory") {
      await commit("SET_FNB_SELECTED_SUB_CATEGORY", event);
    }
  },
  onAddFnBList: async ({ dispatch, commit, state }, { ...payload }) => {
    if (state.multifnbFlag) {
      await commit("SET_ADDED_ITEM_FLAG", payload);
    } else {
      if (
        payload &&
        payload.has_alternate_items &&
        payload.has_alternate_items == "Y"
      ) {
        store.dispatch("onFetchAlternateItems", {
          item_id: payload.item_id,
          index: payload.itemIndex,
          quantity: payload.quantity || 1,
        });
      } else {
        await commit("ADD_ON_FNB_ITEMS", payload);
        await dispatch("fetchFnBAdditionalPrice", payload);
        if (
          payload &&
          payload.is_customization_available &&
          payload.is_customization_available == "Y"
        ) {
          store.dispatch("onFetchCustomization", {
            customization_common_id: payload.customization_common_id,
            item_id: payload.item_id
          });

          if (state.isBOFnBSelected == true && false) {
          } else {
            Vue.toasted.show("Please add customization for " + payload.item_name);
          }
        }

        if (
          payload &&
          payload.is_combo &&
          payload.is_combo == "Y"
        ) {
          EventBus.$emit("openComboModal", payload);
        }
      }
    }

    // .then(async () => {
    //     await commit('CALCULATE_FNB_ITEMS_PRICE', payload)
    // })
  },
  onFetchAlternateItems: async (
    { dispatch, commit, state },
    { ...payload }
  ) => {
    await PosFnBService.GetFnbAlternateItems({ item_id: payload.item_id })
      .then(async response => {
        const { data } = response;
        if (data && data.status && data.Records) {
          await commit("SET_ALTERNATE_ITEMS", data.Records);
          await commit("SET_PREV_ITEM_ID", {
            index: payload.index,
            qty: payload.quantity
          });
          await vmVue.$root.$emit("bv::show::modal", "alternate-itmes-modal");
        } else {
          Vue.toasted.show(data.message);
        }
      })
      .catch(err => {
        Vue.toasted.show(err.message);
      });
  },
  onReplaceAlternateItem: async (
    { dispatch, commit, state },
    { ...payload }
  ) => {
    let obj = {
      index: state.prevItemId
    };
    await commit("REMOVE_ON_FNB_ITEMS", obj);
    payload = {
      ...payload,
      quantity: state.prevQty
    };
    await commit("ADD_ON_FNB_ITEMS", payload);
    await dispatch("fetchFnBAdditionalPrice", payload);
    await commit("CALCULATE_FNB_ITEMS_PRICE", payload);
    await vmVue.$root.$emit("bv::hide::modal", "alternate-itmes-modal");
  },
  updateComboPack: async ({ dispatch, commit, state },{ ...payload }) => {
    state.selectedFnbItemList[payload.orderIndex]['final_combo_array'] = payload.finalComboPack;
    state.selectedFnbItemList[payload.orderIndex]['combo_pack'] = _.cloneDeep(payload.combo_pack);
  },
  addFnbItemFromBoxOffice: async (
    { dispatch, commit, state },
    { ...payload }
  ) => {
    await commit("ADD_ON_FNB_ITEMS", payload);
  },
  Add_More_Quantity_For_Item: async (
    { dispatch, commit, state },
    { ...payload }
  ) => {
    await commit("SET_MORE_QUANTITY", payload);
    await dispatch("fetchFnBAdditionalPrice", payload.ItemDetails);

    await commit("CALCULATE_FNB_ITEMS_PRICE", payload);
  },
  onRemoveFnBList: async ({ dispatch, commit, state }, { ...payload }) => {
    await commit("REMOVE_ON_FNB_ITEMS", payload);
    await store.dispatch("ResetCustomizationData");

    await commit("CALCULATE_FNB_ITEMS_PRICE", payload);
    await commit("RESET_SELECTED_CASH", payload);
  },
  onIncreaseFnBItem: async ({ dispatch, commit, state }, { ...payload }) => {
    await commit("INCREASE_FNB_ITEM", payload);
    await commit("CALCULATE_FNB_ITEMS_PRICE", payload);
  },
  onDecreaseFnBItem: async ({ dispatch, commit, state }, { ...payload }) => {
    await commit("DECREASE_FNB_ITEM", payload);
    await commit("CALCULATE_FNB_ITEMS_PRICE", payload);
    await commit("RESET_SELECTED_CASH", payload);
  },
  onDecreaseOfferFnBItem: async (
    { dispatch, commit, state },
    { ...payload }
  ) => {
    let offerFnbItem = state.selectedFnbItemList[payload.index];
    if (offerFnbItem && offerFnbItem.quantity == 1) {
      console.log("Offer Fnb Item Found :", offerFnbItem);
      await store.dispatch("setOfferItemRemoveFlag", true);
    }
    await store.dispatch("onResetOffersAndPrice");
    await commit("DECREASE_FNB_ITEM", payload);
    await commit("CALCULATE_FNB_ITEMS_PRICE", payload);
    await commit("RESET_SELECTED_CASH", payload);
  },
  SetCinemaId: async ({ dispatch, commit, state }, payload) => {
    await commit("SET_FNB_CINEMA", payload);
  },
  showFnBDetails: async ({ dispatch, commit, state }, payload) => {
    await commit("SHOW_FNB_DETAILS", payload);
  },
  onIsVegChange: async ({ dispatch, commit, state }, { event, ...payload }) => {
    await commit("IS_VEG_HANDLER", event);
    await dispatch("fetchFnBItems");
  },
  onResetFnBHandler: async ({ dispatch, commit, state }, { ...payload }) => {
    await commit("RESET_FNB", payload);
    await commit("RESET_SELECTED_CASH", payload);
    await store.dispatch("resetLoyaltyData");
    await store.dispatch("resetCashCardData");
    await store.dispatch("resetCustomerDetails");
    await store.dispatch("ResetAddonData");
    await store.dispatch("ResetCustomizationData");
    await store.dispatch("ResetInvoiceNumberForDeliveryCredit");
    await store.dispatch("ResetPaymentRemark");
    await store.dispatch('onResetEmployeeDetails');
    // await store.dispatch('MAKE_DATA_EMPTY')
    await dispatch("fetchFnBItems");
  },
  onBackFnBHandler: async ({ dispatch, commit, state }, { ...payload }) => {
    //tempFix
    await commit("SET_BoxOfficeCalCulator_Flag", true);
    if (state.BoxofficeCalculator) {
      let userInfo = authenticationService.get("USINFO");
      userInfo["role_name"] = "POS Operator";

      authenticationService.set("USINFO", userInfo);

      router.replace({
        path: "/pos-booking"
      });
      // store.dispatch('onChangeFlag', {
      //     // login: false,
      //     movieDetail: false,
      //     seatLayout: true,
      //     checkout: false
      // })
    }
    // await store.dispatch('MAKE_DATA_EMPTY');
    await dispatch("onResetFnBHandler");
    await dispatch("onResetFnBStoreState");

    store.dispatch("MAKE_SEAT_BOOKING_DETAILS_EMPTY");
    // store.dispatch('onCancelSelectedSeatsHandler');
    // store.dispatch('ON_REMOVE_ALL_SELECTED_SEATS');
  },
  onResetFnBCashAmout: async ({ dispatch, commit, state }, { ...payload }) => {
    await commit("RESET_SELECTED_CASH", payload);
    if (store.getters.isLoyaltyApplied === false) {
      dispatch("validateCustomerPoints", { amount: state.cashInputValue });
    }
  },
  // onCheckout Final

  fetchCalculatorCash: ({ dispatch, commit, state }, { ...payload }) => {
    PosService.getCashDenominations()
      .then(result => {
        const { data } = result;
        if (data && data.status && data.Records.length > 0) {
          commit("SET_CASH_CALCULATOR", data.Records);
        } else {
          Vue.toasted.show(data.message || "Please try later");
        }
      })
      .catch(error => {
        Vue.toasted.show(
          error || "Catch Error on fetchCalculatorCash store FnB"
        );
      });
  },

  setLoyaltyProgramAmount: async (
    { dispatch, commit, state },
    { event, ...payload }
  ) => {
    await commit("SET_AMOUNT_LOYALITY", payload);
  },
  addCashHandler: async (
    { dispatch, commit, state },
    { event, ...payload }
  ) => {
    await commit("SET_SELECTED_CASH", payload);
    await commit("SET_CHANGE_AMOUT", payload);
    if (store.getters.isLoyaltyApplied === false) {
      dispatch("validateCustomerPoints", { amount: state.cashInputValue });
    }
  },
  changeAmount: ({ dispatch, commit, state }, { ...payload }) => {
    // changeAmount
  },
  cashInputChange: async ({ dispatch, commit, state }, payload) => {
    await commit("SET_INPUT_AMOUNT", payload.target.value);
    await commit("SET_CHANGE_AMOUT", payload);
  },
  // On Order Submit
  onSelectPaymentType: async ({ dispatch, commit, state }, payload) => {
    dispatch("SET_CASH_INPUT", 0);
    commit("CHANGE_PAYMENT_MODE", payload);
  },
  onBoxOfficeAndFnBOrderSubmit: async (
    { dispatch, commit, state },
    payload
  ) => {
    console.log("payload :>> ", payload);
    console.log("payload.isSplitPayment :>> ", payload.isSplitPayment);
    let returnflag = true;
    let fnbItemsArray = [];
    if (store.getters.usedCashCards && store.getters.usedCashCards.length > 0) {
      let res = await dispatch("validateCashCardBalance");
      if (res.status == false) returnflag = false;
    }
    if (returnflag) {
      if (state.selectedFnbItemList.length > 0) {
        state.selectedFnbItemList.map(x => {
          let obj = {
            item_id: x.item_id,
            item_code: x.item_code,
            quantity: x.quantity,
            additionalTaxes: x.additionalTaxes,
            customizations: x.customizations,
            is_combo: x.is_combo || 'N',
            final_combo_array: x.final_combo_array || []
          };

          fnbItemsArray.push(obj);
        });

        // if(store.getters.getAllPaymentCreditCardTrxDetails && Object.keys(store.getters.getAllPaymentCreditCardTrxDetails).length > 0) {
        //   let reservationId = payload.reservationId ? payload.reservationId : payload;
        //   let paymentModeId = state.selectedPaymentMode ? state.selectedPaymentMode.pm_id: 1;
        //   if(store.getters.getAllPaymentCreditCardTrxDetails.hasOwnProperty('ECRReferenceNumber') && store.getters.getAllPaymentCreditCardTrxDetails['ECRReferenceNumber'] == reservationId) {
        //     if(!['2','3'].includes(String(paymentModeId))) {
        //       let pm_object_array = store.getters.paymentModes.filter((pm) => ['2','3'].includes(pm.pm_id))
        //       if(pm_object_array && pm_object_array.length > 0) {
        //         let pm_object = pm_object_array[0]
        //         dispatch('setPaymentMode', pm_object)
        //       }
        //     }
        //   } else {
        //     commit('SET_ALL_PAYMENT_CREDIT_CARD_TRANSATION_DATA', '')
        //   }
        // }

        let tempPaymentMode =  {
          pm_id: 1,
          pm_payment_mode: "Cash"
        };

        let hardwareId = window.localStorage.getItem("deiviceUniqueCode");
        let hardwareMacAddress = window.localStorage.getItem("hardware_mac_address");
        if(!hardwareId || !hardwareMacAddress) {
          var userAgent = navigator.userAgent.toLowerCase();
          if (userAgent.indexOf(" electron/") > -1) {
            let sys_info = await getResourceUsageInfo();
            const key = Object.keys(sys_info.macAddress)[0];
            hardwareMacAddress = sys_info.macAddress[key].mac;
            window.localStorage.setItem("hardware_mac_address", hardwareMacAddress);
          }
        }

        let body = {
          // ...state.fnbPayload,
          onlyFnb: false,
          isPOS: true,
          pos_user_id: authenticationService.get("USINFO").user_id,
          payment_remark: store.getters.getPaymentRemark || null,
          invoice_no_for_delivery_credit: store.getters.getInvoiceNumberForDeliveryCredit || null,
          fnb_station_id: state.selectedStation['station_id'] || null,
          fnb_station_name: state.selectedStation['station_name'] || null,
          hardware_id: window.localStorage.getItem("HWUID")
          ? window.localStorage.getItem("HWUID")
          : window.localStorage.getItem("deiviceUniqueCode") ? window.localStorage.getItem("deiviceUniqueCode") : null,
          hardware_name: window.localStorage.getItem("hardware_name")
            ? window.localStorage.getItem("hardware_name")
            : null,
          hardware_mac_address: window.localStorage.getItem("hardware_mac_address")
            ? window.localStorage.getItem("hardware_mac_address")
            : hardwareMacAddress,
          fnbItemList: fnbItemsArray,
          cinema_id: state.fnbPayload.cinema_id || payload.cinema_id,
          currency_id: state.currency.curr_id || payload.currency_id,
          ft_currency_name:
            state.currency.curr_code || store.getters.GET_CURRENCY,
          ft_net_amount:
            state.selectedFnBItemsTotalPrice +
            store.getters.customizationTotalPrice,
          ft_total_amount:
            state.selectedFnBItemsTotalPrice +
            state.totalAdditionalTaxes +
            store.getters.customizationTotalPrice,
          // ft_date_time: store.getters.SHOW_DETAILS.ss_start_date_time,
          // ft_unix: store.getters.SHOW_DETAILS.ss_start_date_time,
          fst_booking_source: "BoxOffice and Concession",
          booking_source_id: 6,
          ft_actual_date:
            store.getters.SHOW_DETAILS && store.getters.SHOW_DETAILS.actualDate
              ? store.getters.SHOW_DETAILS.actualDate
              : moment().format("YYYY-MM-DD"),
          ft_order_status: 3, // 3 is for payment in success, 18 is for payment in Progress
          // payment_mode_id: 1, // set id for payment mode // 1 is for cash
          payment_mode_id: store.getters.selectedPaymentMode.pm_id
            ? store.getters.selectedPaymentMode.pm_id
            : 1,
          payment_mode: store.getters.selectedPaymentMode
            ? store.getters.selectedPaymentMode
            : tempPaymentMode,
          trx_authorized_by: store.getters.GET_MANAGER_AUTHORIZEDBY_ID || null,
          tim_trx_details: store.getters.getCreditCardTransactionDetails || null,
          card_trx_details: store.getters.getAllPaymentCreditCardTrxDetails || null,
          card_gateway_service: store.getters.getCardGatewayService || null,
          nl_credit_card_name: store.getters.getNlCardName || null,
          stockDeduction: state.stockDeduction || "Y",
          stockDeductionConcession: state.stockDeductionConcession || "Y",
          customer_id: store.getters.cust_id,
          isLoyaltyApplied: store.getters.isLoyaltyApplied,
          eWalletDetails: store.getters.getWalletDetails,
          isWalletApplied: store.getters.getWalletDetails['is_applied'] || "N",
          // customerPointsToBeBurn: store.getters.customerPointsToBeBurn,
          customerPointsToBeBurn: store.getters.getBurnPoints,
          employee_discount_details: Object.keys(store.getters.getSelectedOffer).length > 0
            ? store.getters.getSelectedOffer.hasOwnProperty('is_employee_offer') && store.getters.getSelectedOffer['is_employee_offer'] == 'Y' 
            ? store.getters.getEmployeeDetails 
            : null
            : null,
          //offer
          // offer: state.offerApplied
          //TODO to shift calculation to backend
          offer: {
            t_offer_price:
              (store.getters.selectedFnBItemsTotalPrice /
                (store.getters.selectedFnBItemsTotalPrice +
                  store.getters.TOTAL_AMOUNT)) *
              store.getters.getOfferPrice,
            oc_discount_value: store.getters.getOfferPrice,
            is_on_net_amount: null,
            is_on_net_amount: null,
            is_offer_for: store.getters.getOfferFor,
            ...store.getters.getSelectedOffer
          },
          isGroupRateCard: store.getters.isGroupExist
        };
        if (
          store.getters.selectedAddons &&
          store.getters.selectedAddons.length > 0
        ) {
          body["addOns"] = store.getters.selectedAddons;
        }
        if (store.getters.getOfferFor === "offersAndPromotions") {
          body.offer["is_on_net_amount"] =
            store.getters.getSelectedOffer["offer_applicable_on_net_amount"] ||
            "N";
          body.offer["is_on_gross_amount"] =
            store.getters.getSelectedOffer[
            "offer_applicable_on_gross_amount"
            ] || "N";
        } else if (store.getters.getOfferFor === "vouchers") {
          body.offer["is_on_net_amount"] =
            store.getters.getSelectedOffer["voucher_redeem_on_net"] || "N";
          body.offer["is_on_gross_amount"] =
            store.getters.getSelectedOffer["voucher_redeem_on_gross"] || "N";
        } else if (
          store.getters.isLoyaltyApplied &&
          store.getters.getBurnPoints > 0
        ) {
          // body.offer["t_offer_price"] = store.getters.getloyaltyAmount;
          body.offer["t_offer_price"] = store.getters.getFnbLoyaltyAmount;
          // body.offer["oc_discount_value"] = store.getters.loyaltyAmount;
          body.offer["oc_discount_value"] = store.getters.getFnbLoyaltyAmount;
          body.offer["is_offer_applied"] = true;
          body.offer["offer_title"] = store.getters.LoyaltyProgram;
          body.offer["is_offer_for"] = "offersAndPromotions";
          body.offer["is_on_net_amount"] = "N";
          body.offer["is_on_gross_amount"] = "Y";
        } else if(store.getters.GET_MERIT_GIFT_CARD_DETAILS.isApplied == 'Y' && store.getters.GET_MERIT_GIFT_CARD_DETAILS.amount > 0) {
          // body.offer["t_offer_price"] = store.getters.GET_MERIT_GIFT_CARD_DETAILS.amount;
          // body.offer["oc_discount_value"] = store.getters.GET_MERIT_GIFT_CARD_DETAILS.amount;
          // body.offer["is_offer_applied"] = true;
          // body.offer["offer_title"] = store.getters.GET_MERIT_GIFT_CARD_DETAILS.LoyaltyProgram;
          // body.offer["is_offer_for"] = "offersAndPromotions";
          // body.offer["is_on_net_amount"] = "N";
          // body.offer["is_on_gross_amount"] = "Y";
          body["isMeritLoyalityApplied"] = store.getters.GET_MERIT_GIFT_CARD_DETAILS.isApplied;
          body["meritCardDetails"] = store.getters.GET_MERIT_GIFT_CARD_DETAILS;
        }
        let loader = Vue.$loading.show();
        // console.log('body 222 :', body);
        let fnbItems = "";
        state.selectedFnbItemList.map(x => {
          fnbItems += x.item_name + " * " + x.quantity + " , ";
        });
        //Save Box oFfice log

        //Sabe Fnb Logs

        // for (let i of body.fnbItemList) {
        // }

        await commit("SET_COMBINE_LOYALITY", store.getters.getloyaltyAmount);
        await store.dispatch("onSetAndSendLog", {
          action: `FNB ITEMS SELECTED  are : ${fnbItems} `,
          page_name: "BOX OFFICE & FNB",
          api_name: ""
        });

        await store.dispatch("onSetAndSendLog", {
          action: `FNB total: ${(
            state.selectedFnBItemsTotalPrice + state.totalAdditionalTaxes
          ).toFixed(3)}  Box Office total: ${parseFloat(
            store.getters.TOTAL_AMOUNT
          ) - parseFloat(store.getters.getOfferPrice)} and Total Bill : ${(
            parseFloat(
              state.selectedFnBItemsTotalPrice + state.totalAdditionalTaxes
            ) +
            (parseFloat(store.getters.TOTAL_AMOUNT) -
              parseFloat(store.getters.getOfferPrice))
          ).toFixed(3)}`,
          page_name: "Box-office fnb booking",
          api_name: ""
        });

        // await commit(
        //   "SET_EARNED_POINTS_AFTER_FNB_BOOKING",
        //   data.Records.earnPoints
        // );

        // await commit("ON_SET_TRANSACTION_ID", data.Records);
        // commit("SET_FTID", data.Records);

        // console.log('data.Records ON_SET_TRANSACTION_ID:>> ', data.Records);
        await store.dispatch("insertBoxOfficeTransaction", {
          reservationId: store.getters.reservationId,
          ft_id: state.FnBEjsData.ft_id,
          isSplitPayment: payload.isSplitPayment,
          withFnb: true,
          fnbData: body
        });
        // dispatch('GoToRoute', { path: '/pos-fnb-order-details' });
        if (payload.isPackageTicket) {
          store.dispatch("BOOKING_COMPLETE");
        } else {
          dispatch("onSwtichModule", {
            name: "showFnBOrderDetails"
          });
        }
        loader.hide();
        return false;

        console.log("body1 manav", body);
        PosFnBService.OnFinalOrderSubmit(body)
          .then(async response => {
            const { data } = response;
            loader.hide();

            if (data && data.status) {
              await commit(
                "SET_COMBINE_LOYALITY",
                store.getters.getloyaltyAmount
              );
              await store.dispatch("onSetAndSendLog", {
                action: `FNB ITEMS SELECTED  are : ${fnbItems} `,
                page_name: "BOX OFFICE & FNB",
                api_name: ""
              });

              await store.dispatch("onSetAndSendLog", {
                action: `FNB total: ${(
                  state.selectedFnBItemsTotalPrice + state.totalAdditionalTaxes
                ).toFixed(3)}  Box Office total: ${parseFloat(
                  store.getters.TOTAL_AMOUNT
                ) -
                parseFloat(store.getters.getOfferPrice)} and Total Bill : ${(
                  parseFloat(
                    state.selectedFnBItemsTotalPrice +
                    state.totalAdditionalTaxes
                  ) +
                  (parseFloat(store.getters.TOTAL_AMOUNT) -
                    parseFloat(store.getters.getOfferPrice))
                ).toFixed(3)}`,
                page_name: "Box-office fnb booking",
                api_name: ""
              });

              await commit(
                "SET_EARNED_POINTS_AFTER_FNB_BOOKING",
                data.Records.earnPoints
              );

              await commit("ON_SET_TRANSACTION_ID", data.Records);
              commit("SET_FTID", data.Records);
              // console.log('data.Records ON_SET_TRANSACTION_ID:>> ', data.Records);
              await store.dispatch("insertBoxOfficeTransaction", {
                reservationId: store.getters.reservationId,
                ft_id: state.FnBEjsData.ft_id,
                isSplitPayment: payload.isSplitPayment,
                withFnb: true
              });
              // dispatch('GoToRoute', { path: '/pos-fnb-order-details' });
              if (payload.isPackageTicket) {
                store.dispatch("BOOKING_COMPLETE");
              } else {
                dispatch("onSwtichModule", {
                  name: "showFnBOrderDetails"
                });
              }
            } else {
              store.dispatch("onSetAndSendLog", {
                action: `ERROR : ${data.message}`,
                page_name: "Box-office fnb booking",
                api_name: ""
              });
              Vue.toasted.show(data.message || "Opps! Something went wrong");
            }
          })
          .catch(error => {
            // store.dispatch("onSetAndSendLog", {
            //     action: `ERROR : ${error}`,
            //     page_name: "Box-office fnb booking",
            //     api_name: ""
            // });
            console.log("error :>> ", error);
            Vue.toasted.show("Catch Error on FnBStore fnborder", error);
          });
      } else if (store.getters.selectedAddons.length > 0) {
        store.dispatch("insertBoxOfficeTransaction", {
          reservationId: store.getters.reservationId,
          isSplitPayment: payload.isSplitPayment
        });
        dispatch("onSwtichModule", {
          name: "showFnBOrderDetails"
        });
      } else {
        Vue.toasted.show("Please Select Something to proceed");
      }
    } else {
      commit("SHOW_GENERATE_BUTTON");
      Vue.toasted.show("Cash Card has Insufficient Balance, Pay Again!");
      commit("ON_RESET_CASH_CARD_DATA");
      dispatch("getCashCards", { cust_id: store.getters.cust_id });
    }
  },
  onOrderSubmit: async ({ dispatch, commit, state }, payload) => {
    let returnflag = true;
    let fnbItemsArray = [];
    if(!store.getters.GET_FNB_RESERVATION_CHECK_ARRAY.includes(state.ft_reservation_id)) {
      if (store.getters.usedCashCards && store.getters.usedCashCards.length > 0) {
        let res = await dispatch("validateCashCardBalance");
        if (res.status == false) returnflag = false;
      }
      if (returnflag) {
        state.selectedFnbItemList.map(x => {
          let obj = {
            item_id: x.item_id,
            item_code: x.item_code,
            quantity: x.quantity,
            additionalTaxes: x.additionalTaxes,
            customizations: x.customizations,
            is_combo: x.is_combo || 'N',
            final_combo_array: x.final_combo_array || []
          };

          fnbItemsArray.push(obj);
        });

        // if(store.getters.getAllPaymentCreditCardTrxDetails && Object.keys(store.getters.getAllPaymentCreditCardTrxDetails).length > 0) {
        //   let reservationId = payload.reservationId ? payload.reservationId : payload;
        //   let paymentModeId = state.selectedPaymentMode ? state.selectedPaymentMode.pm_id: 1;
        //   if(store.getters.getAllPaymentCreditCardTrxDetails.hasOwnProperty('ECRReferenceNumber') && store.getters.getAllPaymentCreditCardTrxDetails['ECRReferenceNumber'] == reservationId) {
        //     if(!['2','3'].includes(String(paymentModeId))) {
        //       let pm_object_array = store.getters.paymentModes.filter((pm) => ['2','3'].includes(pm.pm_id))
        //       if(pm_object_array && pm_object_array.length > 0) {
        //         let pm_object = pm_object_array[0]
        //         dispatch('setPaymentMode', pm_object)
        //       }
        //     }
        //   } else {
        //     commit('SET_ALL_PAYMENT_CREDIT_CARD_TRANSATION_DATA', '')
        //   }
        // }

        let hardwareId = window.localStorage.getItem("deiviceUniqueCode");
        let hardwareMacAddress = window.localStorage.getItem("hardware_mac_address");
        if(!hardwareId || !hardwareMacAddress) {
          var userAgent = navigator.userAgent.toLowerCase();
          if (userAgent.indexOf(" electron/") > -1) {
            let sys_info = await getResourceUsageInfo();
            const key = Object.keys(sys_info.macAddress)[0];
            hardwareMacAddress = sys_info.macAddress[key].mac;
            window.localStorage.setItem("hardware_mac_address", hardwareMacAddress);
          }
        }

        commit("SET_FNB_RESERVATION", state.ft_reservation_id);

        let body = {
          // ...state.fnbPayload,
          onlyFnb: true,
          isPOS: true,
          pos_user_id: authenticationService.get("USINFO").user_id,
          payment_remark: store.getters.getPaymentRemark || null,
          invoice_no_for_delivery_credit: store.getters.getInvoiceNumberForDeliveryCredit || null,
          fnb_station_id: state.selectedStation['station_id'] || null,
          fnb_station_name: state.selectedStation['station_name'] || null,
          ft_reservation_id: store.getters.ft_reservation_id || randomAlphaNumeric(),
          hardware_id: window.localStorage.getItem("HWUID")
          ? window.localStorage.getItem("HWUID")
          : window.localStorage.getItem("deiviceUniqueCode") ? window.localStorage.getItem("deiviceUniqueCode") : null,
          hardware_name: window.localStorage.getItem("hardware_name")
            ? window.localStorage.getItem("hardware_name")
            : null,
          hardware_mac_address: window.localStorage.getItem("hardware_mac_address")
            ? window.localStorage.getItem("hardware_mac_address")
            : hardwareMacAddress,
          eWalletDetails: store.getters.getWalletDetails,
          isWalletApplied: store.getters.getWalletDetails['is_applied'] || "N",
          isCashCardActive: store.getters.isCashCardActive,
          CashCardDetails: store.getters.isCashCardDetail,
          isCashCardTransaction: store.getters.isCashCardTransaction,
          fnbItemList: fnbItemsArray,
          cinema_id: state.fnbPayload.cinema_id,
          currency_id: state.currency.curr_id,
          ft_currency_name: state.currency.curr_code,
          trx_authorized_by: store.getters.GET_MANAGER_AUTHORIZEDBY_ID || null,
          tim_trx_details: store.getters.getCreditCardTransactionDetails || null,
          card_trx_details: store.getters.getAllPaymentCreditCardTrxDetails || null,
          card_gateway_service: store.getters.getCardGatewayService || null,
          nl_credit_card_name: store.getters.getNlCardName || null,
          ft_net_amount:
            state.selectedFnBItemsTotalPrice +
            store.getters.customizationTotalPrice,
          ft_total_amount:
            state.selectedFnBItemsTotalPrice +
            state.totalAdditionalTaxes +
            store.getters.customizationTotalPrice,
          fst_booking_source: "Concession",
          ft_actual_date: moment().format("YYYY-MM-DD"),
          ft_order_status: 3, // 3 is for payment in success, 18 is for payment in Progress
          // payment_mode_id: 1, // set id for payment mode // 1 is for cash
          payment_mode_id: store.getters.selectedPaymentMode && store.getters.selectedPaymentMode.pm_id
              ? store.getters.selectedPaymentMode.pm_id
              : 1,
          payment_mode: store.getters.selectedPaymentMode
            ? store.getters.selectedPaymentMode
            : {
                pm_id: 1,
                pm_payment_mode: "Cash",
              },
          stockDeduction: state.stockDeduction,
          stockDeductionConcession: state.stockDeductionConcession,
          customerPointsToBeBurn: store.getters.getBurnPoints,
          customer_id: store.getters.cust_id,
          isLoyaltyApplied: store.getters.isLoyaltyApplied,
          usedCashCards: store.getters.isCashCardTransaction
            ? store.getters.usedCashCards.map(obj => {
              return { cash_card_id: obj.cash_card_id };
            })
            : [],
          isSplitPayment:
            payload.isSplitPayment && payload.isSplitPayment == true
              ? true
              : false,
          //offer
          // offer: state.offerApplied
          VoucherAmount:
            parseFloat(
              parseFloat(store.getters.getOfferPrice) +
              parseFloat(store.getters.RemainingCashRefundOffer)
            ) || null,
          multi_currency_id: state.multiCurrencyId
            ? state.multiCurrencyId
            : state.global_curr_id
              ? state.global_curr_id
              : null,
          currency_value_given: state.multiCurrencyAmount
            ? state.multiCurrencyAmount
            : state.cashInputValue
              ? state.cashInputValue
              : null,
          currency_per_amount: state.multiCurrencyConversionRate
            ? state.multiCurrencyConversionRate
            : 1,
          employee_discount_details: Object.keys(store.getters.getSelectedOffer).length > 0
            ? store.getters.getSelectedOffer.hasOwnProperty('is_employee_offer') && store.getters.getSelectedOffer['is_employee_offer'] == 'Y' 
            ? store.getters.getEmployeeDetails 
            : null
            : null,
          offer: {
            t_offer_price: store.getters.getOfferPrice,
            oc_discount_value: store.getters.getOfferPrice,
            offer_comment: store.getters.getVoucherComment,
            is_on_net_amount: null,
            is_on_net_amount: null,
            is_offer_for: store.getters.getOfferFor,
            is_offer_applied:
              Object.keys(store.getters.getSelectedOffer).length > 0
                ? true
                : false,
            ...store.getters.getSelectedOffer
          }
        };

        if (payload.isSplitPayment && payload.isSplitPayment == true) {
          body["splitPayments"] = store.getters.paymentModes;
        }
        if (
          store.getters.selectedAddons &&
          store.getters.selectedAddons.length > 0
        ) {
          body["addOns"] = store.getters.selectedAddons;
        }
        if (store.getters.getOfferFor === "offersAndPromotions") {
          body.offer["is_on_net_amount"] =
            store.getters.getSelectedOffer["offer_applicable_on_net_amount"] ||
            "N";
          body.offer["is_on_gross_amount"] =
            store.getters.getSelectedOffer["offer_applicable_on_gross_amount"] ||
            "N";
        } else if (store.getters.getOfferFor === "vouchers") {
          body.offer["is_on_net_amount"] =
            store.getters.getSelectedOffer["voucher_redeem_on_net"] || "N";
          body.offer["is_on_gross_amount"] =
            store.getters.getSelectedOffer["voucher_redeem_on_gross"] || "N";
        } else if (
          store.getters.isLoyaltyApplied &&
          store.getters.getBurnPoints > 0
        ) {
          // body.offer["t_offer_price"] = store.getters.getloyaltyAmount;
          body.offer["t_offer_price"] = store.getters.getFnbLoyaltyAmount;
          body.offer["oc_discount_value"] = store.getters.loyaltyAmount;
          body.offer["is_offer_applied"] = true;
          body.offer["offer_title"] = store.getters.LoyaltyProgram;
          body.offer["is_offer_for"] = "offersAndPromotions";
          body.offer["is_on_net_amount"] = "N";
          body.offer["is_on_gross_amount"] = "Y";
        } else if(store.getters.GET_MERIT_GIFT_CARD_DETAILS.isApplied == 'Y' && store.getters.GET_MERIT_GIFT_CARD_DETAILS.amount > 0) {
          // body.offer["t_offer_price"] = store.getters.GET_MERIT_GIFT_CARD_DETAILS.amount;
          // body.offer["oc_discount_value"] = store.getters.GET_MERIT_GIFT_CARD_DETAILS.amount;
          // body.offer["is_offer_applied"] = true;
          // body.offer["offer_title"] = store.getters.GET_MERIT_GIFT_CARD_DETAILS.LoyaltyProgram;
          // body.offer["is_offer_for"] = "offersAndPromotions";
          // body.offer["is_on_net_amount"] = "N";
          // body.offer["is_on_gross_amount"] = "Y";
          body["isMeritLoyalityApplied"] = store.getters.GET_MERIT_GIFT_CARD_DETAILS.isApplied;
          body["meritCardDetails"] = store.getters.GET_MERIT_GIFT_CARD_DETAILS;
        }
        let fnbItems = "";
        state.selectedFnbItemList.map(x => {
          fnbItems += x.item_name + " * " + x.quantity + " , ";
        });
        let loader = Vue.$loading.show();
        console.log("--------------body----- :", body);
        PosFnBService.OnFinalOrderSubmit(body)
          .then(async response => {
            const { data } = response;
            loader.hide();
            if (data && data.status) {
              await commit("SET_AMOUNT_LOYALITY", store.getters.getloyaltyAmount);
              await store.dispatch("onSetAndSendLog", {
                action: `FNB ITEMS SELECTED  are : ${fnbItems} `,
                page_name: "FNB booking",
                api_name: ""
              });
              await store.dispatch("onSetAndSendLog", {
                action: `FNB Total: ${(
                  state.selectedFnBItemsTotalPrice +
                  state.totalAdditionalTaxes -
                  store.getters.getOfferPrice
                ).toFixed(3)} AND ORDER Code: ${data.Records.orderCode}`,
                page_name: "fnb booking",
                api_name: ""
              });
              await store.dispatch("onSetAndSendLog", {
                action: `Cash input was ${state.cashInputValue
                  } and cash given back : ${(
                    state.cashInputValue -
                    (state.selectedFnBItemsTotalPrice +
                      state.totalAdditionalTaxes -
                      store.getters.getOfferPrice)
                  ).toFixed(3)} `,
                page_name: "fnb booking",
                api_name: ""
              });
              console.log("data. :", data.Records);
              commit("ON_SET_TRANSACTION_ID", data.Records);
              // dispatch('GoToRoute', { path: '/pos-fnb-order-details' });
              dispatch("onSwtichModule", {
                name: "showFnBOrderDetails"
              });

              await commit(
                "SET_EARNED_POINTS_AFTER_FNB_BOOKING",
                data.Records.earnPoints
              );
            } else {
              if(data.hasOwnProperty('notAuthorized') && data.notAuthorized) {
                store.dispatch('LogoutUserTokenExpired')
              }
              store.dispatch("onSetAndSendLog", {
                action: `ERROR : ${data.message}`,
                page_name: "fnb booking",
                api_name: ""
              });
              Vue.toasted.show(data.message || "Opps! Something went wrong");
            }
          })
          .catch(error => {
            // store.dispatch("onSetAndSendLog", {
            //     action: `ERROR : ${error}`,
            //     page_name: "fnb booking",
            //     api_name: ""
            // });
            commit("RESET_FNB_RESERVATION");
            Vue.toasted.show(
              "Catch Error on FnBStore fetchFnBAdditionalPrice",
              error
            );
          }).finally(() => {
            EventBus.$emit("enableCheckOutBtn");
          })
      } else {
        EventBus.$emit("enableCheckOutBtn");
        commit("SHOW_GENERATE_BUTTON");
        Vue.toasted.show("Cash Card has Insufficient Balance, Pay Again!");
        commit("ON_RESET_CASH_CARD_DATA");
        dispatch("getCashCards", { cust_id: store.getters.cust_id });
      }
    } else {
      Vue.toasted.show("Transaction Processing, Please Wait!");
    }
  },
  SendPrintDetails: async ({ dispatch, commit, state }, { ...payload }) => {
    await commit("SET_PICKUP_DETAILS", payload);
  },
  ClearPrintDetails: async ({ dispatch, commit, state }, { ...payload }) => {
    await commit("CLEAR_PICKUP_DETAILS", payload);
  },
  GoToRoute: async ({ dispatch, commit, state }, { ...payload }) => {
    function RoundOff(value) {
      if (value) {
        return Math.round(value * 100) / 100;
      } else {
        return "-";
      }
    }
    if (
      payload &&
      payload.path === "printCall" &&
      state.CinemaDetails.length > 0
    ) {
      let rawHTML = `
            <div class="ticket-wrapper">
            <div class="ticket-section">
              <table style="margin: 0 auto">
                <tbody>
                  <tr>
                    <td>
                    <p>${state.CinemaDetails[0].cine_name}</p>

                      <div>${state.CinemaDetails[0].cine_address}</div>
                    <div>${state.CinemaDetails[0].cine_phone}</div>
                      <div>Served by: ${state.userDetails ? state.userDetails : ""
        } ${moment().format("MM-DD-YYYY HH:mm:ss")}</div>
                      <div>Order ID: ${state.OrderId}</div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <table style="margin: 0 auto; width: 100%;">
                <tbody>
                  <tr>
                    <td style="text-align: left;">
                      <span style="border-bottom: 1px dashed; padding-bottom: 10px;">Item</span>
                    </td>
                    <td>
                      <span style="border-bottom: 1px dashed; padding-bottom: 10px;">Qty</span>
                    </td>
                    <td>
                      <span style="border-bottom: 1px dashed; padding-bottom: 10px;">Price</span>
                    </td>
                  </tr>`;

      let Promises = state.selectedFnbItemList.map(x => {
        rawHTML += `<tr>
                    <td style="padding-top: 15px; text-align: left;">${x.item_name}</td>
                    <td style="padding-top: 15px;">${x.quantity}</td>
                    <td style="padding-top: 15px;">${x.fp_total_amount}</td>
                    </tr>`;
      });
      await Promise.all(Promises);

      rawHTML += `</tbody>
              </table>
              <table style="margin: 0 auto; width: 100%; margin-top: 8px;">
                <tbody>
                  <tr>
                    <td style="width: 50%; text-align: left;">Sub Total</td>
                    <td style="width: 50%; text-align: right; padding-right: 4px;">${state.currency.curr_code.toUpperCase()}&nbsp;${RoundOff(
        state.selectedFnBItemsTotalPrice
      )}</td>
                  </tr>`;
      if (
        store.getters.getSelectedOffer &&
        Object.keys(store.getters.getSelectedOffer).length > 0
      ) {
        rawHTML += `<tr>
                  <td style="width: 50%; text-align: left;">${store.getters
            .getSelectedOffer.offer_title ||
          store.getters.getSelectedOffer.voucher_title}</td>
                  <td style="width: 50%; text-align: right; padding-right: 4px;">${state.currency.curr_code.toUpperCase()}&nbsp;${RoundOff(
            store.getters.getOfferPrice
          )}</td>
                  </tr>`;
      }
      let PromisesTaxes = state.additionalTaxList.map(x => {
        rawHTML += ` <tr>
                    <td style="width: 50%; text-align: left;">${x.ct_name.toUpperCase()}</td>
                    <td style="width: 50%; text-align: right; padding-right: 4px;">${state.currency.curr_code.toUpperCase()}&nbsp;${RoundOff(
          x.totalTax
        )}</td>
                </tr>
                `;
      });

      // let changeAmount = state.ChangeAmount > (RoundOff(state.selectedFnBItemsTotalPrice) + RoundOff(state.totalAdditionalTaxes)) ? state.ChangeAmount - (RoundOff(state.selectedFnBItemsTotalPrice) + RoundOff(state.totalAdditionalTaxes) - store.getters.getOfferPrice) : 0;
      let changeAmount =
        state.ChangeAmount &&
          state.ChangeAmount >
          RoundOff(state.selectedFnBItemsTotalPrice) +
          RoundOff(state.totalAdditionalTaxes)
          ? state.ChangeAmount -
          (RoundOff(state.selectedFnBItemsTotalPrice) +
            RoundOff(state.totalAdditionalTaxes))
          : store.getters.getOfferPrice && store.getters.getOfferPrice > 0
            ? state.ChangeAmount -
            (RoundOff(state.selectedFnBItemsTotalPrice) +
              RoundOff(state.totalAdditionalTaxes) -
              RoundOff(store.getters.getOfferPrice))
            : 0;
      await Promise.all(PromisesTaxes);
      rawHTML += `<tr>
                    <td style="width: 50%; text-align: left; font-weight: bold;">Total</td>
                    <td
                      style="width: 50%; text-align: right; padding-right: 4px; font-weight: bold;"
                    >${state.currency.curr_code.toUpperCase()}&nbsp;${RoundOff(
        state.selectedFnBItemsTotalPrice
      ) + RoundOff(state.totalAdditionalTaxes)}</td>
                  </tr>
                  <tr>
                    <td style="width: 50%; text-align: left;">Cash</td>
                    <td style="width: 50%; text-align: right; padding-right: 4px;">${state.cashInputValue
        }</td>
                  </tr>
                  <tr>
                    <td style="width: 50%; text-align: left;">Change</td>
                    <td style="width: 50%; text-align: right; padding-right: 4px;">${changeAmount}</td>
                  </tr>
                </tbody>
              </table>
              <table style="margin-top: 8px;">
                <tbody>
                  <tr>
                    <td style="text-align: left;">
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>`;
      printJS({
        type: "raw-html",
        printable: rawHTML,
        style: `.ticket-section {
                    text-align: center;
                    height: calc(100% - 52.913385826px);
                    padding: 8px;
                  }
                  .ticket-wrapper {
                    width: 302.36220472px;
                    height: 100%;
                    border: 1px solid #000000;
                  }
                  td {
                    padding: 0px;
                  }`
      });

      commit("CHANGE_TEXT", payload);

      // router.push({
      //     path: '/pos-fnb-print-ticket'
      // });
    } else {
      router.push({
        path
      });
    }
  },

  // On
  OnPhoneNumberSubmitHandler: async ({ dispatch, commit, state }, payload) => {
    // Call API or Save Number
    if (payload) {
      PosFnBService.OnSaveFnBPhoneNumber({
        ft_mobile_no: payload.phonenumber,
        ft_id: state.ft_id
      })
        .then(response => {
          const { data } = response;
          data.message
            ? Vue.toasted.show(data.message || "Opps! Something went wrong")
            : "";
          if (data && data.status) {
          }
        })
        .catch(error => {
          console.log("error :", error);
          Vue.toasted.show(
            "Sorry! Something went wrong. kindly contact your administrator"
          );
        });
    } else {
      Vue.toasted.show("Phone Number is empty");
    }
  },
  onPosFnbPrintTicket: async ({ dispatch, commit, state }, payload) => {
    console.log("print :");
  },
  ADD_CUSTOMIZATION_TO_ITEM: async ({ dispatch, commit, state }, payload) => {
    await commit("ADD_CUSTOMIZATION", payload);
  },
  onRemoveCustomization: async ({ dispatch, commit, state }, payload) => {
    await commit("REMOVE_CUSTOMIZATION", payload);
    await store.dispatch("REMOVE_SELECTED_CUSTOMIZATON", payload);
  }
  // On
};

const getters = {
  getFnBItemsModule: state => state.FnBItemsModule,
  fnbItems: state => state.fnbItemList,
  fnbCategories: state => state.fnbCategories,
  fnbSubSubCategories: state => state.fnbSubCategories,
  fnbMoreCategories: state => state.fnbMoreCategories,
  getFnBCurrency: state => state.currency,
  getPaging: state => state.paging,
  SelectedFnbItemList: state => state.selectedFnbItemList,
  selectedFnBItemsTotalPrice: state => state.selectedFnBItemsTotalPrice,
  TotalAdditionalTaxes: state => state.totalAdditionalTaxes,
  Cashdata: state => state.cashdata,
  ChangeAmount: state => state.ChangeAmount,
  AdditionalTaxList: state => state.additionalTaxList,
  isPaymentTypeCash: state => state.paymentTypes,
  isBoxofficeflag: state => state.BoxofficeCalculator,
  isFloatAmountValue: state => state.FlatAmountValue,
  getOrderId: state => state.OrderId,
  cinemadetails: state => state.CinemaDetails,
  IDforFnBEjs: state => state.FnBEjsData,
  PosMultiFnbFlag: state => state.multifnbFlag,
  onAddItem: state => state.AddedItem,
  isFnbDataLoading: state => state.isFnbDataLoading,
  getAlternateItems: state => state.AlternateItems,
  getFnbloyaltyAmount: state => state.FnbLoyalityProgram,
  getCombineLoyalityAmount: state => state.combineLoyaltyAmount,
  getEarnedPointsAfterFnbBooking: state => state.pointsEarnedAfterFnbBooking,
  getFnbItemLength: state => state.fnbItemsLength,
  allFoodCategory: state => state.allFoodCategory,
  GET_FNB_STATIONS: state => state.FnbStations,
  GET_SELECTED_STATION: state => state.selectedStation,
  GET_FNB_RESERVATION_CHECK_ARRAY: state => state.fnb_reservation_id_check_array,
  ft_reservation_id: state => state.ft_reservation_id,
  getEarnedPointsAfterBoxOfficeBooking: state =>
    state.pointsEarnedAfterBoxOfficeBooking
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/FnBStore.js